<template>
  <v-btn v-bind="$attrs" elevation="0" color="info" v-on="$listeners"><slot></slot></v-btn>
</template>

<script>
export default {
  name: "CaSubmit"
};
</script>
